import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { addProductCampaign } from "../../../../store/action/campaignsAction";
import Modal from "../../../shared/components/modal";
import { formatPrice } from "../../../../services/helpers/Helper";
const _ = require('lodash');

const FormManual = (props) => {
   const params = useParams();
   const { id } = params;
   const { onClose, addProductCampaign, campaign, itemSelectProductWarehouse } = props;
   const valueDefault = {
      campaigns_manage_id: id,
      product_name: '',
      product_code: '',
      product_unit: '',
      product_original_price: '',
      product_selling_price: '',
      purchase_limits: '',
      is_active: 1,
      keywords: []
   }
   const errorDefault = {
      product_name: '',
      product_code: '',
      product_selling_price: '',
   }
   const [listProducts, setListProducts] = useState([valueDefault]);
   const [errorProducts, setErrorProducts] = useState([errorDefault]);

   const handleAddProductManual = () => {
      setListProducts(oldValue => {
         return [...oldValue, valueDefault]
      });
      setErrorProducts(oldValue => {
         return [...oldValue, errorDefault]
      });
   }

   const onChangeValue = (index, e) => {
      const name = e.target.name;
      let value = e.target.value;
      setListProducts(oldValue => {
         if (name == 'product_selling_price' || name == 'product_original_price' || name == 'product_unit' || name == 'purchase_limits') {
            value = _.replace(value, /\D/g, '');
         }
         oldValue[index] = { ...oldValue[index], [name]: value };
         return [...oldValue];
      });
   }

   const validate = () => {
      let listKey = [];
      let check = false;
      let listError = [];
      try {
         campaign?.products?.map((m) => {
            m.keywords.map((m2) => {
               listKey.push(m2.keyword);
            });
         });
      } catch (error) {

      }
      listProducts.map((m, i) => {
         let error = {};
         if (!m.product_name) {
            error.product_name = "Vui lòng nhập tên sản phẩm";
            check = true;
         }
         if (!m.product_selling_price) {
            error.product_selling_price = "Vui lòng nhập giá";
            check = true;
         }
         if (m.keywords.length == 0) {
            if (!m.product_code) {
               error.product_code = "Vui lòng nhập mã sản phẩm";
               check = true;
            } else {
               setListProducts(oldValue => {
                  oldValue[i].keywords = [{
                     campaigns_manage_id: id,
                     keyword: m.product_code
                  }];
                  oldValue[i].product_code = '';
                  return [...oldValue];
               });
            }
         } else {
            const listKey2 = m?.keywords?.map((m) => m.keyword);
            if (listKey.some(s => listKey2.includes(s)) || listKey2.length !== new Set(listKey2).size) {
               error.product_code = "Mã bị trùng. Vui lòng nhập mã khác"
               check = true;
            } else {
               listKey = [...listKey, ...listKey2]
            }
         }
         listError.push(error);
      });
      setErrorProducts(listError);

      return check;
   }

   const handleCreate = () => {
      if (!validate()) {
         addProductCampaign(listProducts, id, onClose);
      }

   }

   const onRemoveKeyword = (index, index2) => {
      setListProducts(oldValue => {
         oldValue[index].keywords.splice(index2, 1);
         return [...oldValue];
      });
   }

   const handleSetKeyword = (e, index) => {
      const value = e.target.value;
      if (e.keyCode == 13 && value) {
         setListProducts(oldValue => {
            let keywords = oldValue[index].keywords
            if (!keywords) {
               oldValue[index].keywords = [{
                  campaigns_manage_id: id,
                  keyword: value
               }];
            } else {
               oldValue[index].keywords = [...keywords, {
                  campaigns_manage_id: id,
                  keyword: value
               }];
            }
            oldValue[index].product_code = ''
            return [...oldValue];
         });
      }
   }

   const handleDeleteProductManual = (index) => {
      setListProducts(oldValue => {
         if (oldValue.length == 1) {
            return [valueDefault];
         }
         oldValue.splice(index, 1);
         return [...oldValue];
      });
      setErrorProducts(oldValue => {
         if (oldValue.length == 1) {
            return [errorDefault];
         }
         oldValue.splice(index, 1);
         return [...oldValue]
      });
   }

   const handleCopyProductManual = (index) => {
      setListProducts(oldValue => {
         return [...oldValue, listProducts[index]];
      });
      setErrorProducts(oldValue => {
         return [...oldValue, errorDefault]
      });
   }

   useEffect(() => {
      if (itemSelectProductWarehouse.length > 0) {
         let products = [];
         let error = [];
         itemSelectProductWarehouse.map((item) => {
            let value = {
               campaigns_manage_id: id,
               product_name: item.name,
               product_code: '',
               product_unit: item.product_unit,
               product_original_price: item.product_cost,
               product_selling_price: item.product_price,
               purchase_limits: '',
               is_active: 1,
               keywords: [],
               product_id: item.id,
               product_image: item.product_image
            };
            if (item.code) {
               value.keywords = [{
                  campaigns_manage_id: id,
                  keyword: item.code
               }]
            }
            products.push(value);
            error.push(errorDefault)
         });
         setListProducts(products);
         setErrorProducts(error);

      }
   }, [itemSelectProductWarehouse])

   return (
      <Modal>
         <div className="modal-dialog app-modal app-v2-modal popup-add-product-custom modal-lg" role="document">
            <div className="modal-content">
               <div className="app-modal-header">
                  <h4 className="app-modal-title">
                     <div className="app-v2-modal-header">
                        <div className="custom">
                           <div className="display-flex">
                              <span>Thêm nhanh hàng loạt sản phẩm </span>
                              <span className="total-product text font-size-12 line-height-20 mt1">(1)</span>
                           </div>
                           {/* <div className="display-flex border-radius4 input-with-icon disabled font-size-14 text-no-bold">
                              <div className="left-icon">
                                 <div className="svg-next-icon ic-search-2">
                                 </div>
                              </div>
                              <div className="input-container">
                                 <input type="text" placeholder="Tìm theo mã, tên sản phẩm, mã SKU" value="" disabled="" />
                              </div>
                           </div> */}
                        </div>
                        <div className="icon-wrapper" onClick={onClose}>
                           <span className="icon-close app-close">
                              <div className="svg-next-icon ic-modal-close" >
                              </div>
                           </span>
                        </div>
                     </div>
                  </h4>
               </div>
               <div className="app-modal-body">
                  <div className="table-container flex-1 flex-display-col w100">
                     <div className="table-add-product scrollable-horizontal-left scrollable-horizontal-right">
                        <div className="header">
                           {/* <div className="col-checkbox">
                              <div className="app-next-input-checkbox header-checkbox select-all app-input-disabled">
                                 <label
                                    className="app-next-label--switch app-next-label--empty" for="app-checkbox-10">
                                 </label>
                                 <input id="app-checkbox-10" type="checkbox" className="app-next-checkbox" disabled="" />
                                 <span className="app-next-checkbox--styled">
                                    <span className="app-svg-next-icon app-checkmark">
                                       <svg className="app-svg-inline-block" width="10px" height="10px" viewBox="0 0 26 26">
                                          <path d="m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z">
                                          </path>
                                       </svg>
                                    </span>
                                 </span>
                              </div>
                           </div> */}
                           <div className="col-name">
                              Tên sản phẩm
                              <span className="required">*</span>
                              <span className="pointer app-horver-tooltip"><div className="svg-next-icon ic-help"></div></span>
                              <div className="app-tooltip  app-tooltip-placement-top app-horver-tooltip-point" style={{ left: 8, top: -40 }}>
                                 <div className="app-tooltip-content">
                                    <div className="app-tooltip-arrow"></div>
                                    <div className="app-tooltip-inner" role="tooltip">Tên sản phẩm tùy biến không được trùng nhau.</div>
                                 </div>
                              </div>
                           </div>
                           <div className="col-keyword">
                              <span className="title  rounded-3  line-height-20 px-2">
                                 Mã sản phẩm
                              </span>
                              <span className="required">*</span>
                              <span className="pointer app-horver-tooltip">
                                 <div className="svg-next-icon ic-help"></div>
                              </span>
                              <div className="app-tooltip  app-tooltip-placement-top app-horver-tooltip-point" style={{ left: 241, top: -52 }}>
                                 <div className="app-tooltip-content">
                                    <div className="app-tooltip-arrow"></div>
                                    <div className="app-tooltip-inner" role="tooltip">
                                       Mã sản phẩm không được trùng nhau và nên nhập từ 2 - 4 ký tự, tránh các chữ cái dễ hiểu nhầm.
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div className="col-price">Giá bán<span className="required">*</span></div>
                           <div className="col-price">Giá gốc</div>
                           <div className="col-quantity">
                              Số lượng mở bán
                           </div>
                           <div className="col-limit-order">
                              Giới hạn mua /1 khách
                              
                           </div>
                           <div className="col-action">Hành động</div>
                        </div>
                        <div className="virtual-scroll-container scrollbar-narrow" style={{ overflow: "auto", maxHeight: 360 }}>
                           {listProducts.map((item, index) => {
                              return (
                                 <div className="row-item line-break" key={index}>
                                    {/* <div className="col-checkbox">
                                       <div className="app-next-input-checkbox app-input-disabled">
                                          <label className="app-next-label--switch app-next-label--empty" for="app-checkbox-13">
                                          </label>
                                          <input id="app-checkbox-13" type="checkbox" className="app-next-checkbox" disabled="" />
                                          <span className="app-next-checkbox--styled">
                                             <span className="app-svg-next-icon app-checkmark">
                                                <svg className="app-svg-inline-block" width="10px" height="10px" viewBox="0 0 26 26">
                                                   <path d="m.3,14c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1v-8.88178e-16c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.4 0.4,1 0,1.4l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-7.8-8.4-.2-.3z">
                                                   </path>
                                                </svg>
                                             </span>
                                          </span>
                                       </div>
                                    </div> */}
                                    <div className="col-name">
                                       <div className={`display-flex border-radius4 input-with-icon ${errorProducts[index].product_name && " border-error"}`}>
                                          <div className="input-container">
                                             <input type="text" name="product_name" value={item.product_name} onChange={(e) => onChangeValue(index, e)} />
                                          </div>
                                       </div>
                                       {!!errorProducts[index].product_name &&
                                          <div className="inline-error mt8 line-height-20" title={errorProducts[index].product_name}>{errorProducts[index].product_name}</div>
                                       }
                                    </div>
                                    <div className="col-keyword">
                                       <div className={`input-keyword display-flex border-radius4 input-with-icon ${!!errorProducts.keywords && "border-error"}`} style={{ border: '1px solid #e3e9ed' }}>
                                          {item?.keywords?.map((item2, index2) => {
                                             return (
                                                <div className="app-badges app-badges--status-primary-string input-keyword__badges" onClick={() => onRemoveKeyword(index, index2)} key={index2}>
                                                   <div className="app-badges-body" >
                                                      <span className="text-nowrap content" title={item2.keyword}>
                                                         {item2.keyword}
                                                      </span>
                                                      <div className="pointer button-delete">
                                                         <div>
                                                            <div className="svg-next-icon next-close-2">
                                                            </div>
                                                         </div>
                                                      </div>
                                                   </div>
                                                </div>
                                             )
                                          })}
                                          <input className="input-keyword__text text-no-bold"
                                             name="product_code"
                                             value={item.product_code}
                                             onKeyDown={(e) => handleSetKeyword(e, index)}
                                             onChange={(e) => onChangeValue(index, e)} />
                                       </div>
                                       {!!errorProducts[index].product_code &&
                                          <div className="inline-error mt8 line-height-20" title={errorProducts[index].product_code}>{errorProducts[index].product_code}</div>
                                       }
                                    </div>
                                    <div className="col-price">
                                       <div className="display-flex border-radius4 input-with-icon">
                                          <div className="input-container">
                                             <input type="text" name="product_selling_price" value={formatPrice(item.product_selling_price) + " đ"} onChange={(e) => onChangeValue(index, e)} />
                                          </div>
                                          <div className="right-icon">
                                             <div className="svg-next-icon pointer ic-modal-close-2" >
                                             </div>
                                          </div>
                                       </div>
                                       {!!errorProducts[index].product_selling_price &&
                                          <div className="inline-error mt8 line-height-20" title={errorProducts[index].product_selling_price}>{errorProducts[index].product_selling_price}</div>
                                       }
                                    </div>
                                    <div className="col-price">
                                       <div className="display-flex border-radius4 input-with-icon">
                                          <div className="input-container">
                                             <input type="text" name="product_original_price" value={formatPrice(item.product_original_price) + " đ"} onChange={(e) => onChangeValue(index, e)} />
                                          </div>
                                          <div className="right-icon">
                                             <div className="svg-next-icon pointer ic-modal-close-2">
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-quantity">
                                       <div className="box-quantity">
                                          <div className="display-flex border-radius4 input-with-icon">
                                             <div className="input-container">
                                                <input type="text" name="product_unit" value={item.product_unit} onChange={(e) => onChangeValue(index, e)} />
                                             </div>
                                          </div>
                                          <div className="quantity-read-only" title="-">-</div>
                                       </div>
                                    </div>
                                    <div className="col-limit-order">
                                       <div className="display-flex border-radius4 input-with-icon">
                                          <div className="input-container">
                                             <input type="text" name="purchase_limits" value={item.purchase_limits} onChange={(e) => onChangeValue(index, e)} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-action">
                                       <span className="mr16 pointer" onClick={() => handleDeleteProductManual(index)}>
                                          <div className="svg-next-icon ic-recycle-bin-two-lines-new">
                                          </div>
                                       </span>
                                       <span className="pointer" onClick={() => handleCopyProductManual(index)}>
                                          <div className="svg-next-icon ic-copy">
                                          </div>
                                       </span>
                                    </div>
                                 </div>
                              )
                           })}
                        </div>
                     </div>
                  </div>
               </div>
               <div className="app-modal-footer">
                  <div className="col-auto">
                     <div className="add-row inline-flex-display content-center pointer" onClick={handleAddProductManual}>
                        <div className="svg-next-icon ic-plus-circle-3">
                        </div>
                        <span className="ml5 line-height-20 text-font-weight-500 color-blue-line-through">
                           Thêm sản phẩm tùy biến
                        </span>
                     </div>
                     <div className="action">
                        <button type="button" className="app-btn app-btn-default app-v2-btn-default" onClick={onClose}>Hủy</button>
                        <button disabled="" type="button" className="app-btn app-btn-primary" onClick={handleCreate}>Xác nhận</button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </Modal>
   )
}

const mapStateToProps = (state) => {
   const { campaign, page } = state;
   return {
      campaign,
      page,
   };
};


export default connect(mapStateToProps, {
   addProductCampaign
})(FormManual)
